import { Box, styled } from "@mui/material";

export const DateRangeContainer = styled(Box)(() => ({
  display: "grid",
  width: "100%",
  gridTemplateColumns: "50px 3fr 20px 3fr",
  justifyContent: "center",
  alignItems: "center",
  alignContent: "center",
  justifyItems: "center",
}));

export const HeaderRow = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr max-content",
  gap: theme.spacing(1),
  justifyContent: "center",
  alignItems: "center",
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const ButtonBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));


export const ChipsContent = styled("div")(() => ({
  maxWidth: "90%",
}));

export const PermissionBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginLeft: theme.spacing(1)
}));

export const DocumentBox = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "grid",
  gap: theme.spacing(1),
  gridTemplateColumns: "1fr",
  gridTemplateRows: "auto 1fr auto",
}));